module.exports = __webpack_public_path__ + "img/service-zhunongjinrong1.fc9816b3.svg";